
<template>
  <div id="app" :class="[page, this.skin]">
    <globalModal :show="isWeixin"/>
    <base-layout/>
  </div>
</template>

<script>
import BaseLayout from './components/layout/BaseLayout'
import util from "@/util";

window.dataLayer = []
window._mtm = []

export default {
  name: 'app',
  components: {
    BaseLayout
  },
  data() {
    return {
      isWeixin: false
    }
  },
  methods: {
    isLogin() {
      // 是否是使用条款或者隐私政策路由/reset psw/change psw, 是：不做处理; 否：判断登录
      const currentRoute = ['TermsOfUse', 'PrivacyPolicy', 'ResetPassword', 'ChangePassword', 'Login'].find(x => x === this.$route.name)
      if(!currentRoute) {
        // 是否登录  否：跳转登录页
        if(!localStorage.Authorization) {
          this.$router.push({name: 'Login'})
          // 是否强改密码 是：跳转改密码；否：不做操作，正常显示首页；
        } else if (localStorage.isForceChange == 'true') {
          this.$router.push({name: 'UserCenter'})
        }
      }
    },

    gaInit() {
      // this.$store.state.dataLayerReady = false
      if (!this.$store.state.dataLayerReady) {
        this.$axios.get('/api/trackingCodes?portal=employee').then((res) => {
          if (res.code === 200 && res.data.length) {

            const arr = res.data
            arr.forEach((ga) => {
              util.loadJs(ga.script_type, ga.script_code, ga.location)
            })

            this.$store.commit('stateChange', {k: 'dataLayerReady', v: true})
          }
        })
      }
    },

  },
  computed: {
    page() {
      return this.$route.name?.toLocaleLowerCase()
    },
    device() {
      return window.innerWidth
    },
    skin() {
      return this.$store.state.gaData.skinCode
    },
    lang() {
      return this.$store.state.gaData.lang
    },
    UA() {
      const inBrowser = typeof window !== 'undefined';
      const inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
      const weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
      const UA = inBrowser && window.navigator.userAgent.toLowerCase();
      const isIE = UA && /msie|trident/.test(UA);
      const isIE9 = UA && UA.indexOf('msie 9.0') > 0;
      const isEdge = UA && UA.indexOf('edge/') > 0;
      const isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
      const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
      const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
      const isPhantomJS = UA && /phantomjs/.test(UA);
      const isFF = UA && UA.match(/firefox\/(\d+)/);
      const isMobile = UA && UA.indexOf('mobile') > 0
      const isWechat = UA && UA.indexOf('micromessenger') > 0
      return {
        isIE,
        isIE9,
        isEdge,
        isAndroid,
        isIOS,
        isChrome,
        isPhantomJS,
        isFF,
        inWeex,
        weexPlatform,
        isMobile,
        isWechat,
        UA
      }

    },
    netCode() {
      return this.$store.state.netCode
    },
  },
  created() {
    // 登录状态验证
    this.isLogin()
    if (this.page !== 'payment') {
      localStorage.removeItem("form");
    }if(this.skin == 'sjm') {
      document.getElementsByTagName('body')[0].style.fontFamily = 'Lato, Helvetica, Arial, sans-serif';
      document.getElementsByTagName('body')[0].style.color = '#676868';
    }

    this.gaInit()
  },
  watch: {
    netCode(obj) {
      if(obj == 401) {
        // 后台登出，清除缓存并跳转页面
        localStorage.removeItem('Authorization')
        localStorage.removeItem('isForceChange')
        localStorage.removeItem('username')
        localStorage.removeItem('employee_quota')
        localStorage.removeItem('employee_rate')
        localStorage.removeItem('fnf_quota')
        localStorage.removeItem('fnf_rate')
        this.$router.push({name: 'Login'})
      }
    }
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase()
    this.isWeixin = ua.includes('micromessenger')
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', AvenirLTS, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
